export default __webpack_public_path__ + "static/media/coi-expirience-mobile.8b4c8e04.png";